/**
 * evolution-buff.ts — 進化「單場微 buff」純函式(老闆 2026-06-06 拍板 §4.2 選項 2)。
 *
 * 鐵則(雙軌分離,最高風險區 — 見 docs/spec/CHARACTER_SYSTEM_DESIGN.md §4.2 + §8):
 *  - 此檔**只計算數字**,絕不讀寫 progress / factionXP / skillLevels。
 *  - 呼叫端(horizontal-battle-scene `_applyEvolution`)把回傳值加進**當局** RunModifiers
 *    (RunModifiers 每場 new、跨場歸零),性質同升級卡的單場加成。
 *  - 強度**綁 factionXp**:學得少(xp→0)→ buff→0;想要進化更兇 → 去學習。
 *    確保「玩遊戲不灌永久戰力」——進化變身的數值意義由學習軌決定。
 *
 * 判準自檢(§4.2):進化 buff 會讓「同一關更易打贏」嗎?會 → 必須綁 factionXp 上限 +
 * 當局歸零。本函式滿足:xp=0 時回 0(沒學就沒加成),且呼叫端寫的是單場 RunModifiers。
 */

/**
 * 計算某進化階段的「單場子彈傷害加成」。純函式。
 * @param stage     進化階段(1=基礎不加、2=evo2、3=evo3)。
 * @param factionXp 該英雄門派的 factionXP(學習軌)。<=0 → 回 0。
 * @returns 要加到當局 RunModifiers.bulletDamageBonus 的整數(>=0)。
 */
export function computeEvolutionDamageBuff(stage: number, factionXp: number): number {
  if (stage < 2) return 0;
  const xp = Math.max(0, factionXp);
  const CAP = 3000; // factionXP 封頂:buff 不無限增長(守戰鬥平衡,微 buff 性質)
  const t = Math.min(1, xp / CAP); // 0..1:學越多越接近封頂
  const base = stage >= 3 ? 6 : 3; // evo3 最多 +6、evo2 最多 +3(單場微 buff)
  return Math.round(base * t); // xp=0 → 0(沒學就沒進化 buff)
}
